import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=4fdc337b&scoped=true"
import script from "./historyRecord.vue?vue&type=script&lang=js"
export * from "./historyRecord.vue?vue&type=script&lang=js"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=4fdc337b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc337b",
  null
  
)

export default component.exports